import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { isAuthenticated, logout } from "./api";

const menuItems = [
  { path: "/dashboard", label: "Dashboard", icon: "iconsminds-dashboard" },
  { path: "/shop-usage", label: "Shop Usage", icon: "simple-icon-chart" },
  { path: "/knowledge", label: "Knowledge Base", icon: "iconsminds-library" },
  { path: "/configs", label: "AI Config", icon: "simple-icon-settings" },
  { path: "/conversations", label: "Conversations", icon: "simple-icon-bubbles" },
  { path: "/audit-logs", label: "Audit Logs", icon: "simple-icon-list" },
];

class AiAdminLayout extends Component {
  componentDidMount() {
    if (!isAuthenticated()) {
      this.props.history.push("/login");
    }
  }

  render() {
    if (!isAuthenticated()) return null;

    return (
      <div className="d-flex" style={{ minHeight: "100vh" }}>
        {/* Sidebar */}
        <div
          style={{
            width: 240,
            background: "linear-gradient(180deg, #2d1b69 0%, #1a1a2e 100%)",
            color: "#fff",
            flexShrink: 0,
          }}
        >
          <div className="p-3 text-center border-bottom" style={{ borderColor: "rgba(255,255,255,0.1)" }}>
            <h5 className="mb-0 font-weight-bold" style={{ color: "#a78bfa" }}>
              VMASS AI
            </h5>
            <small style={{ color: "rgba(255,255,255,0.5)" }}>Admin Dashboard</small>
          </div>

          <nav className="py-3">
            {menuItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className="d-flex align-items-center px-3 py-2 text-decoration-none"
                activeStyle={{
                  backgroundColor: "rgba(167, 139, 250, 0.2)",
                  borderRight: "3px solid #a78bfa",
                }}
                style={{ color: "rgba(255,255,255,0.7)", fontSize: 14 }}
              >
                <i className={`${item.icon} mr-3`} style={{ fontSize: 16, width: 20 }} />
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="mt-auto p-3" style={{ position: "absolute", bottom: 0, width: 240 }}>
            <button
              className="btn btn-sm btn-outline-light w-100"
              onClick={logout}
              style={{ borderColor: "rgba(255,255,255,0.3)", fontSize: 13 }}
            >
              <i className="simple-icon-logout mr-2" />
              Logout
            </button>
          </div>
        </div>

        {/* Main content */}
        <div className="flex-grow-1" style={{ backgroundColor: "#f4f4f8", overflow: "auto" }}>
          {/* Top bar */}
          <div
            className="d-flex justify-content-between align-items-center px-4 py-2"
            style={{ backgroundColor: "#fff", borderBottom: "1px solid #e9ecef", height: 56 }}
          >
            <h6 className="mb-0 text-muted">AI Management Console</h6>
            <span className="text-muted" style={{ fontSize: 12 }}>
              ai.vmass.vn
            </span>
          </div>

          {/* Page content */}
          <div className="p-4">{this.props.children}</div>
        </div>
      </div>
    );
  }
}

export default withRouter(AiAdminLayout);
